(function () {
    'use strict';

    angular.module('elogbooks.user.exports', []).config(registerRoutes);

    function registerRoutes($stateProvider) {
        $stateProvider
            .state('dashboard.user.exports', {
                abstract: true,
                template: '<bookerize></bookerize>',
                ncyBreadcrumb: {
                    skip: true
                }
            })
            .state('dashboard.user.exports.list', {
                url: '/exports?page&limit&order&exportType&status&queuedAt&startedAt&endedAt&exportId',
                parent: 'dashboard.user.exports',
                params: {
                    page: "1",
                    limit: "30",
                    order: "-id",
                    exportType: null,
                    status:  {
                        value: null
                    },
                    queuedAt: null,
                    startedAt: null,
                    endedAt: null,
                    exportId: null
                },
                resolve: {
                    exportCollectionResponse: function (apiClient, rootResourceResponse, paramsService, $stateParams) {
                        var statusParam = $stateParams.status;
                        statusParam = statusParam == null ? [] : [].concat(statusParam).map(Number);
                        statusParam = statusParam.map(Number);

                        var exportType = null;
                        if ($stateParams.exportType) {
                            try {
                                exportType = JSON.parse($stateParams.exportType).v;
                            } catch (e) {
                                exportType = $stateParams.exportType;
                            }
                        }

                        var params = {
                            page: paramsService.page,
                            limit: paramsService.limit,
                            order: paramsService.order,
                            type: exportType ,
                            'status[]': statusParam,
                            queuedAt: paramsService.queuedAt,
                            startedAt: paramsService.startedAt,
                            endedAt: paramsService.endedAt,
                            id: paramsService.exportId
                        };

                        return apiClient.get(rootResourceResponse.getLink('exports'), params).then(function (response) {
                            return response || apiClient.noResourceFound();
                        });
                    }
                },
                views: parseBook({
                    'elogbooks-left@dashboard.user.exports': {
                        templateUrl: '/modules/user/exports/exports.html',
                        controller: 'ExportsController',
                        controllerAs: 'vm'
                    }
                }),
                ncyBreadcrumb: {
                    label: '{{ ::"EXPORTS" | translate }}'
                }
            });
    }
})();
